// extracted by mini-css-extract-plugin
export default {"container":"HomeLayout_container__ZSJMX","social-profile":"HomeLayout_social-profile__eVfXf","fadeIn":"HomeLayout_fadeIn__49qmV"};